import api from './axios';

export const getActivities = async () => {
    const response = await api.get('/activities');
    return response.data;
};

export const getActivityDetails = async (id) => {
    const response = await api.get(`/activities/${id}`);
    return response.data;
};

export const getFormFields = async (activityId) => {
    const response = await api.get(`/form-fields`, { params: { activityId: Number(activityId) } });
    return response.data;
}

export const createActivity = async (formData) => {
    const response = await api.post('/activities', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const updateActivity = async (id, data) => {
    const response = await api.put(`/activities/${id}`, {
        name: data.name,
        description: data.description,
        imageUrl: data.imageUrl || null,
        activityTypeId: data.activityTypeId,
        startAt: data.startAt,
        endAt: data.endAt,
        isActive: Boolean(data.isActive),
        ...(data.memberPrefix && { memberPrefix: data.memberPrefix })
    });

    return response.data;
};

export const deleteActivity = async (id) => {
    const response = await api.delete(`/activities/${id}`);
    return response.data;
};

export const getActivityTypes = async () => {
    const response = await api.get('/activity-types');
    return response.data;
};